import React, { useState } from 'react';
import cn from 'classnames';
import { CalloutBox, CALLOUTBOX_THEMES } from 'Elements/CalloutBox';
import styles from './styles.scss';

const HELLOTECH_NOW_MESSAGE =
  "We offer HelloTech Now! for services that can be performed by a tech remotely. You can get support right away and we're available 24/7. Not only is HelloTech Now! convenient, it saves you cash!";

const HelloTechNowMessage = () => {
  const [isCalloutVisible, setIsCalloutVisible] = useState(false);
  const toggleMessage = (event) => {
    event.preventDefault();
    setIsCalloutVisible(!isCalloutVisible);
  };
  const containerStyles = cn({
    'paddingY-small': isCalloutVisible,
    'paddingTop-small': !isCalloutVisible,
  });
  return (
    <div className={containerStyles}>
      <a className={styles.messageTitle} onClick={toggleMessage}>
        What is HelloTech NOW?
      </a>
      {isCalloutVisible && (
        <CalloutBox
          className="marginTop-small"
          theme={CALLOUTBOX_THEMES.DEFAULT}
          text={HELLOTECH_NOW_MESSAGE}
        />
      )}
    </div>
  );
};

export default HelloTechNowMessage;
